import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideToast } from "../../store/toast/actions";
import { Toast } from "react-bootstrap";

/**
 * A functional component that renders a toast notification based on the state
 * of the ToastReducer. The toast can be of type "success", "error", or "warning",
 * and displays a corresponding icon and message. The toast can be closed by clicking
 * on the close button or automatically after a delay of 1000ms.
 * @returns The rendered toast component.
 */
const ToastComponent = () => {
  const toast = useSelector((state) => state.ToastReducer.toast);
  const [showToast, setShowToast] = useState(false);
  const dispatch = useDispatch();

  /**
   * useEffect hook that updates the state of `showToast` whenever the `toast.show` value changes.
   * @returns None
   */
  useEffect(() => {
    setShowToast(toast.show);
  }, [toast.show]);

  let toastClass;
  let iconClass = toast.customClass;

  /**
   * Determines the appropriate CSS classes for the given toast type and assigns them to the
   * corresponding variables.
   * @param {object} toast - The toast object containing the type property.
   * @returns None
   */
  if (toast.type === "success") {
    toastClass = "success-txt";
    iconClass = "mdi-check-all";
  } else if (toast.type === "error") {
    toastClass = "error-txt";
    iconClass = "mdi-block-helper";
  } else if (toast.type === "warning") {
    toastClass = "warning-txt";
    iconClass = "mdi-alert-circle-outline";
  } else {
    toastClass = "";
  }

  return (
    /**
     * Renders a Toast component with the specified props.
     * @param {function} onClose - Callback function to be executed when the Toast is closed.
     * @param {string} className - Additional CSS class name(s) to be applied to the Toast.
     * @param {boolean} show - Determines whether the Toast is visible or hidden.
     * @param {number} delay - The duration in milliseconds for which the Toast will be displayed before automatically hiding.
     * @param {boolean} autohide - Determines whether the Toast will automatically hide after the specified delay.
     * @returns The rendered Toast component.
     */
    <Toast
      onClose={() => {
        setShowToast(false);
        setTimeout(() => {
          dispatch(hideToast());
        });
      }}
      className={toastClass}
      show={showToast}
      delay={3000}
      autohide
    >
      <div className="tostcenter">
        <div className="Tost_Content">
          <i className={`mdi ${iconClass}`}></i>
          <div className="txtcontain">
            <strong>{toast.messagebold}</strong> {toast.message}{" "}
          </div>
        </div>
      </div>
    </Toast>
  );
};

export default ToastComponent;
